import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import { message, Tooltip, Popover, Modal } from 'antd';
import {
  SmileOutlined,
  MehOutlined,
  StarFilled,
  StarOutlined,
  AlertOutlined,
  UserOutlined,
  StopOutlined,
  RestOutlined,
  IdcardOutlined,
  LoadingOutlined,
  ScissorOutlined,
} from '@ant-design/icons';
import qs from 'qs';
import html2canvas from 'html2canvas';
import HTTP from '../../script/service';
import Util from '../../script/util';
import WEBIM from '../../store/WebNim';
import {
  _change_remark_modal,
  _refresh_nim_session,
  _change_ds_modal,
  _change_nim_chat,
  _new_room_window,
  _dssp_send_click,
  _tip_off,
  _dssp_show_event,
} from '../../store/Action';
import PrettyNum from '../prettyNum/PrettyNum';
import Share from '../../components/share/Share';
import ScissorImage from './scissorImage';
import TopOrder from './TopOrder';
import TjOrder from './TjOrder';
import Face from './Face';
import Msgs from './Msgs';
import './index.scss';
import { DDLoading } from '../globalPageStatus';

const SEND_IM_ERROR = '内容已失效';
class index extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      beautifulNo: null, //靓号
      showFace: false, //显示表情
      user: null, //聊天对象(NIM-USER)
      godUser: null, //对方的大神资料
      generalUser: null, // 对方的资料
      order: null, //未结束的订单
      hasGivefull: false, //是否还能买二送一
      isUserStatus: false, // 用户账户是否异常
    };
  }
  componentWillUnmount() {
    this.setState = () => {
      return;
    };
  }

  componentDidMount() {
    //订单信息变更
    WEBIM.onConfigFn('_NIM_ORDER_MESSAGE', () => {
      this.getP2Porder();
    });
    this.initQueryData();

    if (this.props.defaultToUser?.account) {
      this.changeToUser(this.props.defaultToUser);
    }
  }
  //初始化数据
  initQueryData = async () => {
    if (!this.props.base.userInfo) return;
    let hasGivefull;
    //是否还能买二送一
    const resoult_2 = await HTTP._is_order_plus_limit();
    if (resoult_2.code == 200) {
      hasGivefull = resoult_2.data;
    }
    //获取自己是否开启防打扰
    if (this.props.base.isOpenIntrusion == null) {
      const resoult_3 = await HTTP._get_rules_byuid({
        uid: this.props.base.uid,
      });
      if (resoult_3.code == 200) {
        this.props.dispatch({
          type: 'set_is_open_intrusion',
          data: { isOpenIntrusion: !!resoult_3.data.ifDnd },
        });
      }
    }
    this.setState({ hasGivefull });
  };
  //获取对话用户
  changeToUser = (obj) => {
    const uid = Util.$analyToUid(obj.account);
    console.log('changeToUser', WEBIM.to);
    if (!WEBIM?.to) return;
    this.setState(
      {
        uid,
        user: { ...obj, uid },
        showFace: false,
        dsUrl: '',
        godUser: null,
        generalUser: null,
        orderNum: 1,
        order: null,
        chatMe: WEBIM.me || null,
        chatTo: WEBIM?.to?.account
          ? WEBIM.users[WEBIM.to.account] || null
          : null,
        isUserStatus: obj.custom ? !!obj.custom.userStatus : 0,
      },
      () => {
        // obj.custom.toBusinessVipLevel.length todo 2.22.3 VIP客服 不查询订单信息，大神信息
        if (
          obj.custom &&
          !obj.custom.userStatus &&
          !obj?.custom?.toBusinessVipLevel?.length
        ) {
          //获取最新订单
          if (obj?.custom?.ifGod == 1 || WEBIM.me?.custom?.ifGod == 1) {
            this.getP2Porder();
          }
          //只有对方是大神才查询
          if (obj?.custom?.ifGod == 1) {
            this.getUserGodInfo();
          } else {
            // 非大神
            if (!obj.custom.sys) {
              this.getUserGeneralInfo();
            }
          }
          //获取用户的靓号信息
          if (!obj.custom.sys) {
            this.getUserBeatifulNo();
          }
        }
      }
    );

    if (WEBIM?.to?.account) {
      // 上报
      _dssp_show_event({
        page_name: '消息',
        tab_name: `消息页`,
        sub_tab_name: ``,
        scene_category: `消息`,
        scene_name: `聊天场景`,
        scene_value: {
          target_uid: Util.$analyToUid(WEBIM.to.account),
        },
      });
    }
  };
  //获取当前订单
  getP2Porder = () => {
    if (!this.state.uid) return;
    const { chatTo } = this.state;
    if (chatTo && chatTo.custom && chatTo.custom.sys) return;
    HTTP._god_2_player({
      godUid: this.state.uid,
      playUid: this.props.base.uid,
    }).then((res) => {
      if (res.code == 200 && res.data) {
        this.setState({ order: res.data });
      } else {
        this.setState({ order: null, orderNum: 1 });
      }
    });
  };
  //获取大神资料
  getUserGodInfo() {
    HTTP._get_new_god_detailed({
      uid: this.state.uid,
      myUid: this.props.base.uid,
    }).then((res) => {
      if (res.code == 200 && res.data) {
        this.setState({
          godUser: res.data,
          orderNum: 1,
          dsUrl: `${window.location.origin}/?dsid=${this.state.uid}`,
        });
      }
    });
  }
  //获取用户的信息
  getUserGeneralInfo() {
    HTTP._get_v4_new_god_detailed({
      uid: this.state.uid,
      myUid: this.props.base.uid || null,
      qKey: 'nimChat1',
    })
      .then((res) => {
        if (res && res.code === 200) {
          this.setState({ generalUser: res.data });
        } else {
          this.setState({ generalUser: null });
        }
      })
      .catch((err) => {
        this.setState({ generalUser: null });
      });
  }
  //获取用户的靓号信息
  getUserBeatifulNo() {
    HTTP._get_user_beatiful_no({ toUid: this.state.uid }).then((res) => {
      if (res && res.code === 200 && !!res.data.beautifulNo) {
        this.setState({ beautifulNo: res.data.beautifulNo });
      } else {
        this.setState({ beautifulNo: null });
      }
    });
  }
  //大神技能卡详情
  get_god_category_detailed = (uid, categoryId) => {
    return new Promise((resolve, reject) => {
      HTTP._get_god_category_detail({ uid, categoryId })
        .then((res) => {
          if (res.code === 200) {
            const category = res.data.godCategoryList.find(
              (item) => item.categoryId === categoryId
            );
            if (!category) {
              resolve({ err: SEND_IM_ERROR });
            }
            const custom = {
              sensitiveWord: 1,
              shareInfo: {
                categoryPrice: `${category.price}`, // 由于 IOS 定义为字符串
                godId: uid,
                pic: category.icon,
                shareType: 3,
                categoryName: category.categoryName,
                categoryUnit: `${category.unit}`,
                categoryId: `${categoryId}`, // 由于 IOS 定义为字符串
              },
              privilegeLevel: 9,
            };
            resolve(custom);
          }
          resolve({ err: SEND_IM_ERROR });
        })
        .catch((err) => {
          resolve({ err: SEND_IM_ERROR });
        });
    });
  };
  //用户资料详情
  get_god_detailed = (uid) => {
    return new Promise((resolve, reject) => {
      HTTP._get_v4_new_god_detailed({
        uid,
        myUid: this.props.base.uid || null,
        qKey: 'nimChat1',
      })
        .then((res) => {
          if (res && res.code === 200) {
            const custom = {
              sensitiveWord: 1,
              shareInfo: {
                nickname: res.data.nickName,
                pic: res.data.headPic,
                shareType: 2,
                sign: res.data.specificSign,
                uid,
              },
              privilegeLevel: 9,
            };
            resolve(custom);
          }
          resolve({ err: SEND_IM_ERROR });
        })
        .catch(() => {
          resolve({ err: SEND_IM_ERROR });
        });
    });
  };
  //查询直播间详情
  get_room_card_info = (roomid) => {
    const { roomTypeDict } = this.props.base;
    return new Promise((resolve, reject) => {
      HTTP._get_room_card_info({ roomid })
        .then((res) => {
          if (res && res.code === 200) {
            const ctype = res.data.extInfo.ctype;
            const roomTypeName = roomTypeDict.find((item) => item.id === ctype);
            const custom = {
              sensitiveWord: 1,
              shareInfo: {
                shareType: 1,
                roomName: res.data.name,
                pic: res.data.extInfo.icon,
                roomId: res.data.roomid,
                roomTypeName: !!roomTypeName ? roomTypeName.text : ctype,
              },
              privilegeLevel: 9,
            };

            resolve(custom);
          }
          resolve({ err: SEND_IM_ERROR });
        })
        .catch(() => {
          resolve({ err: SEND_IM_ERROR });
        });
    });
  };
  //关注
  addFollow = () => {
    let { user, isUserStatus } = this.state;
    if (isUserStatus) {
      message.warning('发送失败，用户异常');
      return;
    }
    HTTP._add_follow_user({
      uid: this.props.base.uid,
      otherUid: Util.$analyToUid(user.account),
    }).then((res) => {
      this.loading = false;
      if (res.code == 200) {
        _dssp_send_click(76, {
          to: Util.$analyToUid(user.account),
        });
        user.fllow.meToOther = 1;
        this.setState({ user: { ...user } });
      } else {
        message.error(res.message);
      }
    });
  };
  //取消关注
  cancelFollow = () => {
    let { user, isUserStatus } = this.state;
    if (isUserStatus) {
      message.warning('发送失败，用户异常');
      return;
    }
    HTTP._cancel_follow_user({
      uid: this.props.base.uid,
      otherUid: Util.$analyToUid(user.account),
    }).then((res) => {
      if (res.code == 200) {
        _dssp_send_click(77, {
          to: Util.$analyToUid(user.account),
        });
        user.fllow.meToOther = 0;
        this.setState({ user: { ...user } });
      } else {
        message.error(res.message);
      }
    });
  };
  //举报
  tipoff = () => {
    const { isUserStatus, user } = this.state;
    if (isUserStatus) {
      message.warning('发送失败，用户异常');
      return;
    }
    if (user) {
      _tip_off({
        type: 1,
        reportType: 1,
        reportedPersonId: Util.$analyToUid(this.state.user.account),
      });
    }
  };
  setRemark = () => {
    const { user } = this.state;
    _change_remark_modal({
      show: true,
      uid: user.uid,
      nickName: user?.nick,
      remarkName: user?.fllow?.otherRemarkName || '',
      callback: (remarkName) => {
        const user1 = WEBIM.users[Util.$analyToAccount(user.uid)];
        user1.fllow = { ...user1.fllow, otherRemarkName: remarkName };
        //更新对话对象
        WEBIM.events['_SET_CURR_USER'] && WEBIM.events['_SET_CURR_USER'](user1);
        _refresh_nim_session({ remarkName });
      },
    });
  };
  //加入黑名单二次确认弹窗
  addBlank = () => {
    const { user, isUserStatus } = this.state;
    if (isUserStatus) {
      message.warning('发送失败，用户异常');
      return;
    }
    Modal.confirm({
      title: '提示',
      icon: null,
      closable: true,
      content: (
        <Fragment>
          <p>
            <span>
              您确定将<label>{user.nick}</label>拉黑吗?
            </span>
          </p>
          <p>拉黑后将不会收到对方消息，该用户将无法对你下单哦~</p>
        </Fragment>
      ),
      className: 'daidai-confirm-style',
      cancelText: '取消',
      okText: '确定',
      centered: true,
      onOk: () => {
        WEBIM.addBlank(user);
      },
    });
  };
  //进入大神首页
  openDsInfo = () => {
    const { godUser } = this.state;
    _change_nim_chat();
    _change_ds_modal({
      dsid: godUser.uid,
      jnid: null,
      ehot: false,
      origin: 'im',
    });
  };
  //修改数量
  changeNum = (num) => {
    let { orderNum } = this.state;
    let count = orderNum + num;
    if (count < 1) {
      count = 1;
    } else if (count > 100) {
      count = 100;
    }
    this.setState({ orderNum: count });
  };
  //直接下单
  addDsOrder = (param) => {
    _change_nim_chat();
    _change_ds_modal(param);
  };
  //显示表情
  toggleFace = (e, bool) => {
    const { isUserStatus } = this.state;
    if (isUserStatus) {
      message.warning('发送失败，用户异常');
      return;
    }
    if (bool !== undefined) {
      this.setState({ showFace: bool });
    } else {
      this.setState({ showFace: !this.state.showFace });
    }
    e.stopPropagation();
  };
  // 判断用户是否可以发送消息给对方
  isSendContent = () => {
    const { isUserStatus } = this.state;
    if (isUserStatus) {
      message.warning('发送失败，用户异常');
      return false;
    }
    return true;
  };
  // 判断自己是否开启了放打扰，如果开启了，则关注对方
  isIntrusionFollowYou = () => {
    const { user } = this.state;
    const { isOpenIntrusion } = this.props.base;
    if (
      isOpenIntrusion != null &&
      !!isOpenIntrusion && // 自己开启了防打扰
      !user.fllow.meToOther // 已关注对方
    ) {
      this.addFollow();
    }
  };
  //添加普通表情
  onSelectEmoji = (emoji, type = null) => {
    if (type) {
      if (!this.isSendContent()) return;
      this.isIntrusionFollowYou();
      const value = {
        data: {
          catalog: emoji.pic,
          chartlet: emoji.name,
        },
        type,
      };
      WEBIM.sendCustomMsg(value);
    } else {
      let value = this.sendElement.value;
      this.sendElement.value = value + emoji;
    }
  };
  //发送我的资料卡
  sendMydsPage = () => {
    const { isUserStatus } = this.state;
    if (isUserStatus) {
      message.warning('发送失败，用户异常');
      return;
    }
    this.sendEvent(`${window.location.origin}?dsid=${this.props.base.uid}`);
  };
  //发送聊天内容
  onSendText = (e) => {
    if (e.nativeEvent.keyCode === 13) {
      this.sendEvent();
      e.stopPropagation();
      e.preventDefault();
    }
  };
  //发送
  sendEvent = async (customText = null) => {
    const { rootConfig } = this.props.base;
    let text = customText ? customText.trim() : this.sendElement.value.trim();
    if (!this.isSendContent()) return;
    if (text.length > 500) {
      message.warning('每次发送内容最大为500字符');
      return;
    }
    if (!text || text === '' || text.length === 0) {
      return;
    }
    if (this.state.sendLoading) return;
    this.setState({ sendLoading: true }, async () => {
      // 分享房间 分享名片 分享资质 - todo 2.7.0 IM分享改版
      const regUrl =
        /(https?:\/\/)([0-9a-z|\-.]+)(:[0-9]+)?([/0-9a-z.]+)?(\?[0-9a-z&=]+)?(#[0-9-a-z]+)?/i;
      const regOrgin = new RegExp(`${window.location.origin}`);
      const regDs = /dsid=\d+/;
      const regJn = /jnid=\d+/;
      const regRoom = /roomid=\d+/;
      let custom = {
        vnum: rootConfig.vnum,
        appCode: rootConfig.companyCode,
        source: rootConfig.source,
      };
      if (regUrl.test(text)) {
        const url = text.match(regUrl)[0];
        let data = qs.parse(url.split('?')[1]);
        if (regOrgin.test(text)) {
          if (regDs.test(text) && regJn.test(text)) {
            // 技能卡片
            custom = await this.get_god_category_detailed(
              data.dsid,
              Number(data.jnid)
            );
          } else if (regDs.test(text)) {
            // 个人名片
            custom = await this.get_god_detailed(data.dsid);
          } else if (regRoom.test(text)) {
            // 房间信息
            custom = await this.get_room_card_info(data.roomid);
          }
          if (custom.err) {
            text = custom.err;
            custom = null;
          }
        }
      }
      WEBIM.sendText(text, custom).then(() => {
        this.setState({ sendLoading: false });
        this.sendElement.value = '';
        this.isIntrusionFollowYou();
      });
    });
  };
  //清屏
  clearHistory = (e) => {
    const { isUserStatus, user } = this.state;
    if (isUserStatus) {
      message.warning('发送失败，用户异常');
      return;
    }
    WEBIM.clearHistory(user.account);
  };
  //截图
  handleScissor = () => {
    const { isUserStatus } = this.state;
    if (isUserStatus) {
      message.warning('发送失败，用户异常');
      return;
    }
    this.setState({ loading: true }, () => {
      // 头部
      const domTop = document.querySelector('#chat-con-plan .right-top');
      html2canvas(domTop, {
        useCORS: true,
        backgroundColor: '#301354',
      }).then((domTopCanvas) => {
        // 中间
        const dom = document.querySelector('#chat-con-plan .right-chat');
        html2canvas(dom, {
          useCORS: true,
          backgroundColor: '#301354',
        }).then((domCanvas) => {
          // 合并
          const canvas = document.createElement('canvas');
          canvas.width = 800;
          canvas.height = 700;
          const content = canvas.getContext('2d');
          content.drawImage(domTopCanvas, 0, 0);
          content.drawImage(domCanvas, 0, 60);
          const src = canvas.toDataURL('image/png');
          this.setState({ loading: false });
          this.cropperElement.showModal(src);
        });
      });
    });
  };
  //进入直播间
  inRoom = () => {
    this.props.close && this.props.close();
    _new_room_window(
      {
        roomid: this.state.godUser.roomid,
        roomname: this.state.godUser.roomName,
      },
      this.props.history,
      null,
      `2|${this.state.godUser.uid}`
    );
    _change_nim_chat();
    _change_ds_modal(null);
  };
  //隐藏所有弹窗
  hideAllModel = (e) => {
    this.setState({ showFace: false });
    e.stopPropagation();
  };
  render() {
    const {
      loading,
      sendLoading,
      user,
      godUser,
      generalUser,
      beautifulNo,
      isUserStatus,
      order,
      orderNum,
      hasGivefull,
      chatMe,
      chatTo,
    } = this.state;
    const { rootConfig, userInfo } = this.props.base;
    let Cheight = '640px',
      CCheight = '640px';
    if (user && user.custom && user.custom.sys) {
      CCheight = '640px';
      Cheight = '640px';
    } else if (user) {
      CCheight = '500px';
      Cheight = '500px';
      if (
        order ||
        (godUser && godUser.godCategoryList && godUser.godCategoryList.length)
      ) {
        Cheight = '440px';
      }
    }
    return (
      <Fragment>
        <DDLoading status={loading}>
          <div
            id="chat-con-plan"
            className="chat-con-plan"
            onClick={this.hideAllModel}
          >
            <div className="right-top">
              <CurrChatUser
                {...{ generalUser, godUser, user, beautifulNo, isUserStatus }}
                inRoom={this.inRoom}
              />
              {!user?.custom?.toBusinessVipLevel?.length && (
                <TopActionLabel
                  user={user}
                  isUserStatus={isUserStatus}
                  addBlank={this.addBlank}
                  setRemark={this.setRemark}
                  tipoff={this.tipoff}
                  cancelFollow={this.cancelFollow}
                  addFollow={this.addFollow}
                />
              )}
            </div>
            <div className="right-chat">
              <div className="chat-window">
                <div className="chat-w-main">
                  <div
                    id="chat-msgs"
                    className="chat-msgs"
                    style={{ height: CCheight }}
                  >
                    {isUserStatus ? null : order ? (
                      <div className="top-order">
                        <TopOrder
                          order={order}
                          base={this.props.base}
                          changeOrder={this.getP2Porder}
                        />
                      </div>
                    ) : (
                      <span>
                        {godUser &&
                        godUser.godCategoryList &&
                        godUser.godCategoryList.length ? (
                          <div className="top-order">
                            <TjOrder
                              base={this.props.base}
                              addDsOrder={this.addDsOrder}
                              changeNum={this.changeNum}
                              godUser={godUser}
                              orderNum={orderNum}
                              hasGivefull={hasGivefull}
                            />
                          </div>
                        ) : null}
                      </span>
                    )}
                    <div
                      className="chat-all-msgs-parent"
                      style={{ height: Cheight }}
                    >
                      {isUserStatus ? (
                        <div className="user-account-error">
                          <span className="account-error-icon" />
                          <p>该用户已被封禁</p>
                        </div>
                      ) : (
                        <Msgs
                          addFollow={this.addFollow}
                          base={this.props.base}
                          me={chatMe}
                          to={chatTo}
                        />
                      )}
                    </div>
                  </div>
                  {user && user.custom && !user.custom.sys && userInfo ? (
                    <div className="chat-bars">
                      <div className="chat-ac-top">
                        <span
                          className={`acc${isUserStatus ? ' disabled' : ''}`}
                          onClick={this.toggleFace}
                        >
                          {this.state.showFace ? (
                            <SmileOutlined />
                          ) : (
                            <MehOutlined />
                          )}
                          <Face
                            base={this.props.base}
                            visible={this.state.showFace}
                            toggleFace={this.toggleFace}
                            onSelectEmoji={this.onSelectEmoji}
                          />
                        </span>
                        {userInfo?.ifGod == 1 ? (
                          <span
                            className={`acc${isUserStatus ? ' disabled' : ''}`}
                            onClick={this.sendMydsPage}
                          >
                            <Tooltip title="资料卡">
                              <IdcardOutlined />
                            </Tooltip>
                          </span>
                        ) : null}
                        <span
                          className={`acc${isUserStatus ? ' disabled' : ''}`}
                          onClick={this.clearHistory}
                        >
                          <Tooltip title="清屏">
                            <RestOutlined />
                          </Tooltip>
                        </span>
                        {window.browserInfo.name !== 'ie' ? (
                          <span
                            className={`acc${isUserStatus ? ' disabled' : ''}`}
                            onClick={this.handleScissor}
                          >
                            <Tooltip title="截图">
                              <ScissorOutlined className="icon-scissor" />
                            </Tooltip>
                          </span>
                        ) : null}
                        <div className="anqun-text">
                          为保障用户权益，请勿使用平台外交易，谨防被骗！
                        </div>
                      </div>
                      {/* 发送内容 */}
                      <div className="send-text">
                        <textarea
                          placeholder="下单前找大神聊一聊..."
                          maxLength="500"
                          ref={(el) => (this.sendElement = el)}
                          onKeyPress={this.onSendText}
                          disabled={isUserStatus}
                        />
                        <button
                          className={`daidai-btn-primary${isUserStatus ? ' disable' : ''}`}
                          onClick={() => this.sendEvent()}
                        >
                          <span>
                            {sendLoading ? (
                              <LoadingOutlined style={{ marginRight: 10 }} />
                            ) : null}
                            <span>发送</span>
                          </span>
                        </button>
                      </div>
                    </div>
                  ) : null}
                </div>
                {godUser ? (
                  <div className="chat-user-info">
                    <div className="info-top">
                      <div className="user-head">
                        <div className="cover" onClick={this.openDsInfo}>
                          <img
                            alt=""
                            src={Util.transImgUrl(godUser.headPic, '75x75')}
                          />
                        </div>
                        <div className="nick">
                          <span className="nick-name">
                            <label>{godUser.nickName}</label>
                            {godUser.sex === 1 ? (
                              <i className="sex-wman" />
                            ) : (
                              <i className="sex-man" />
                            )}
                          </span>
                        </div>
                        <div className="level">
                          {godUser.ifCertAuth == 1 ? (
                            <label className="realname" />
                          ) : (
                            <label className="realname-not" />
                          )}
                          {godUser.wealthHide != 1 && (
                            <i
                              className={`icon-wealth v_${godUser.wealthLevel}`}
                            />
                          )}
                          {godUser.charmHide != 1 && (
                            <i
                              className={`icon-charm v_${godUser.glamourLevel}`}
                            />
                          )}
                          <i className={`icon-sea v_${godUser.nobleLevel}`} />
                        </div>
                        <div className="sign">
                          {godUser.specificSign || '这个人很懒，还没有签名。'}
                        </div>
                      </div>
                      <div className="actions">
                        <span className="ac-item" onClick={this.openDsInfo}>
                          <div className="order"></div>
                          <p>下单</p>
                        </span>
                        <span className="ac-item" onClick={this.openDsInfo}>
                          <div className="card"></div>
                          <p>资料</p>
                        </span>
                        <Popover
                          rootClassName="daidai-popover-default"
                          trigger="click"
                          placement="bottomRight"
                          content={
                            <div>
                              {godUser ? (
                                <Share
                                  url={this.state.dsUrl}
                                  dsid={godUser.uid}
                                  pic={godUser.headPic}
                                  remark={godUser.specificSign}
                                />
                              ) : null}
                            </div>
                          }
                        >
                          <span className="ac-item">
                            <div className="share"></div>
                            <p>分享</p>
                          </span>
                        </Popover>
                        {user.fllow.meToOther ? (
                          <span
                            className="ac-item"
                            title="取消关注"
                            onClick={this.cancelFollow}
                          >
                            <div className="follow"></div>
                            <p>已关注</p>
                          </span>
                        ) : (
                          <span className="ac-item" onClick={this.addFollow}>
                            <div className="follow"></div>
                            <p>关注</p>
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="info-foot">
                      <div className={`f-code ${rootConfig.companyCode}`} />
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </DDLoading>
        <ScissorImage
          wrappedComponentRef={(el) => (this.cropperElement = el)}
          closeLoading={this.closeLoading}
        />
      </Fragment>
    );
  }
}
//获取在线状态
function GetStatusLabel({ user, godUser, inRoom }) {
  //系统账号
  if (user.custom && user.custom.sys) {
    return <span className="status st-gf"></span>;
  }
  //平台角色
  if (user.custom && user.custom.roleId) {
    return <span className={`status st-role-${user.custom.roleId}`}></span>;
  }
  // todo 2.9.5.1 新增判断用户是否在线（全站隐身）
  if (godUser && godUser.roomid && !!godUser.ifOnline) {
    return (
      <span className="status st-room" onClick={inRoom}>
        <i />
      </span>
    );
  }
  let onlineState = WEBIM.getDeviceType(user.account);
  // 使用云信订阅 获取在线状态
  if (!onlineState || onlineState == '离线') {
    return <span className="status st-un-online" />;
  } else {
    return <span className="status st-online" />;
  }
}
//头部
function CurrChatUser({ godUser, user, isUserStatus, beautifulNo, inRoom }) {
  if (!user) return null;
  // 用户异常
  if (!!isUserStatus) {
    return (
      <div className="chat-header">
        <label className="nick">用户异常</label>
      </div>
    );
  }

  return (
    <div className="chat-header">
      <label className="nick">
        {user?.fllow?.otherRemarkName || user?.nick}
      </label>
      <label className="uid">
        <PrettyNum uid={user.uid} num={beautifulNo} style={{ marginTop: 5 }} />
      </label>
      <GetStatusLabel {...{ user, godUser, inRoom }} />
    </div>
  );
}
//头部操作
function TopActionLabel({
  user,
  isUserStatus,
  setRemark,
  cancelFollow,
  addFollow,
  tipoff,
  addBlank,
}) {
  if (!user) return null;
  if (user && user.custom && user.custom.sys) return null;
  if (user && user.custom && user.custom.roleId) return null;
  let blank = WEBIM.blacklist[user.account];
  return (
    <div className="top-actions">
      <span className="ttc fadeInRight animated faster">
        {(user?.fllow?.meToOther && user?.fllow?.otherToMe) ||
        !!user?.fllow?.otherRemarkName ? (
          <Tooltip
            title="备注"
            className={`acc${isUserStatus ? ' disabled' : ''}`}
            onClick={setRemark}
          >
            <span className="mc">
              <i className="icon-edit"></i>
            </span>
          </Tooltip>
        ) : null}
        {user?.fllow?.meToOther ? (
          <Tooltip
            title="取消关注"
            className={`acc${isUserStatus ? ' disabled' : ''}`}
            onClick={cancelFollow}
          >
            <span className="mc">
              <StarFilled />
            </span>
          </Tooltip>
        ) : (
          <span
            title="关注"
            className={`acc${isUserStatus ? ' disabled' : ''}`}
            onClick={addFollow}
          >
            <span className="mc">
              <label className="follow-pic">关注我成为好友吧</label>
              <StarOutlined />
            </span>
          </span>
        )}
        <Fragment>
          <Tooltip
            title="举报"
            className={`acc${isUserStatus ? ' disabled' : ''}`}
            onClick={tipoff}
          >
            <span className="mc">
              <AlertOutlined />
            </span>
          </Tooltip>
          {blank ? (
            <Tooltip
              title="移除黑名单"
              className={`acc${isUserStatus ? ' disabled' : ''}`}
              onClick={() => {
                WEBIM.removeBlank(user.account);
              }}
            >
              <span className="mc">
                <UserOutlined />
              </span>
              <StopOutlined className="min" />
            </Tooltip>
          ) : (
            <Tooltip
              title="加入黑名单"
              className={`acc${isUserStatus ? ' disabled' : ''}`}
              onClick={addBlank}
            >
              <span className="mc">
                <UserOutlined />
              </span>
            </Tooltip>
          )}
        </Fragment>
      </span>
    </div>
  );
}

export default connect((store) => ({ base: store }), null, null, { forwardRef: true })(index);
